import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as R from 'ramda';
import { pagePermissions } from 'src/constants/permission';
import { rolePermissions } from 'src/constants/rolePermission';
import { MenuID, MenuItemType, RoleType } from '../../types';
var clinicRoles = [RoleType.CLINIC_DOCTOR_ROLE, RoleType.CLINIC_BRANCH_MANAGER_ROLE, RoleType.CLINIC_PHARMACIST_ROLE, RoleType.CLINIC_NURSE_ROLE, RoleType.CLINIC_DIETICIAN_ROLE, RoleType.CLINIC_CUSTOMER_SERVICE_ROLE, RoleType.CLINIC_SENIOR_CUSTOMER_SERVICE_ROLE, RoleType.CLINIC_SALESPERSON_ROLE, RoleType.CLINIC_APPOINTMENT_SPECIALIST_ROLE, RoleType.CLINIC_ASSISTANT_ROLE, RoleType.CLINIC_THERAPIST_ROLE, RoleType.CLINIC_ACCOUNTING_ROLE];
var whiteListIDs = [MenuID._3DModel, MenuID.login];
var clinicGroupIDs = [MenuID.reservation, MenuID.onboard, MenuID.client_list, MenuID.deliverynote, MenuID.inventory, MenuID.info_mgmt, MenuID.measurement_mgmt];
var cofitGroupIDs = [MenuID.client_mgmt, MenuID.chatroom];
var statisticGroupIDs = [MenuID.cg_report];
export var analysisGuideIDs = [MenuID.analysisGuide, MenuID.analysisGuideDiet, MenuID.analysisGuideTarget];
export var instantFoodToolIDs = [MenuID.instantFoodTool];
export var RouteAuthorizer = /*#__PURE__*/function () {
  function RouteAuthorizer() {
    _classCallCheck(this, RouteAuthorizer);
  }

  _createClass(RouteAuthorizer, [{
    key: "isRolesIn",
    value: function isRolesIn(roles, targetRoles) {
      return R.intersection(roles, targetRoles).length > 0;
    }
  }, {
    key: "isClinicRole",
    value: function isClinicRole(roles) {
      return this.isRolesIn(roles, clinicRoles);
    }
  }, {
    key: "hasPagePermission",
    value: function hasPagePermission(roles, path) {
      var allPages = roles.flatMap(function (role) {
        var _rolePermissions$role;

        return ((_rolePermissions$role = rolePermissions[role]) === null || _rolePermissions$role === void 0 ? void 0 : _rolePermissions$role.page) || [];
      }).map(function (name) {
        var _pagePermissions$find;

        return (_pagePermissions$find = pagePermissions.find(function (permission) {
          return permission.name === name;
        })) === null || _pagePermissions$find === void 0 ? void 0 : _pagePermissions$find.subject;
      }).filter(function (subject, index, self) {
        return subject && self.indexOf(subject) === index;
      });

      if (Array.isArray(path)) {
        return path.some(function (p) {
          return allPages.includes(p);
        });
      }

      return allPages.includes(path);
    }
  }, {
    key: "checkAuthorized",
    value: function checkAuthorized(_ref) {
      var roles = _ref.roles,
          id = _ref.id,
          type = _ref.type;
      if (type === MenuItemType.group) return this.isGroupAuthorized({
        roles: roles,
        id: id
      });
      if (type === MenuItemType.withSubMenus || type === MenuItemType.externalLink || type === MenuItemType.leavesLevel) return this.hasPagePermission(roles, id);
      return false;
    }
  }, {
    key: "isGroupAuthorized",
    value: function isGroupAuthorized(_ref2) {
      var roles = _ref2.roles,
          id = _ref2.id;
      if (id === MenuID.clinic) return this.hasPagePermission(roles, clinicGroupIDs);
      if (id === MenuID.cofit_pro) return this.hasPagePermission(roles, cofitGroupIDs);
      if (id === MenuID.statistic) return this.hasPagePermission(roles, statisticGroupIDs);
      return false;
    }
  }, {
    key: "isPathnameAuthorized",
    value: function isPathnameAuthorized(_ref3) {
      var roles = _ref3.roles,
          pathname = _ref3.pathname;
      // remove hash and search from URL to get the real pathname
      var url = new URL("https://www.abc.com".concat(pathname));
      url.hash = '';
      url.search = '';
      var path = url.pathname;
      var isWhiteListRoute = R.any(function (name) {
        return name === path;
      }, whiteListIDs);
      if (isWhiteListRoute) return true;
      return this.hasPagePermission(roles, path);
    }
  }, {
    key: "getDefaultPath",
    value: function getDefaultPath(_ref4) {
      var roles = _ref4.roles;
      return this.isClinicRole(roles) ? '/' : MenuID.chatroom;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!RouteAuthorizer.instance) {
        RouteAuthorizer.instance = new RouteAuthorizer();
      }

      return RouteAuthorizer.instance;
    }
  }]);

  return RouteAuthorizer;
}();

_defineProperty(RouteAuthorizer, "instance", void 0);